import PropTypes from 'prop-types';
import React from 'react'

import TextEdit from '~/services/textedit'


export default class extends React.Component {
    static propTypes = {
		resource: PropTypes.object
	};

    render() {

		return (

			<span>{ this.props.resource.title && '"'+TextEdit.cutText(this.props.resource.title, 50)+'"' }</span>

		)
	}
}



// WEBPACK FOOTER //
// ./src/js/components/Notifications/components/Item/components/Preview.js